<div class="table-header">
  <button nz-button nzType="primary" nzShape="round" (click)="showReservaForm()">
    <nz-icon nzType="plus"></nz-icon>
    Nuevo
  </button>
</div>

<app-reservas-table
  [searchable]="true"
  [reservas]="reservas"
  (editReserva)="onEditReserva($event)"
  (deleteReserva)="onDeleteReserva($event)"
  (checkReserva)="onCheckReserva($event)"
></app-reservas-table>

<nz-modal
  [(nzVisible)]="isReciboModalVisible"
  [nzTitle]="'Actualizar Número de Recibo'"
  [nzFooter]="null"
  (nzOnCancel)="handleCancelReciboModal()"
>
  <ng-container *nzModalContent>
    <app-num-recibo
      [(numRecibo)]="numRecibo"
      (submit)="submitReciboForm()"
      (cancel)="handleCancelReciboModal()"
    ></app-num-recibo>
  </ng-container>
</nz-modal>
<nz-modal
  [(nzVisible)]="isEditReservaModalVisible"
  [nzTitle]="'Editar Reserva'"
  [nzFooter]="null"
  (nzOnCancel)="handleCancelEditReservaModal()"
>
  <ng-container *nzModalContent>
    <app-editar-reserva
      [reservaId]="reservaSeleccionada"
      (updateSuccess)="submitEditReservaForm()"
      (cancel)="handleCancelEditReservaModal()"
    ></app-editar-reserva>
  </ng-container>
</nz-modal>
